import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

import EvaluationSection from './EvaluationSection';
import ReviewSection from './ReviewSection';
import MultiReviewComments from '../../review/reviewCategory/textblockReview/MultiReviewComments';

import '../PrintTemplate.css';

const StyledDiv = styled('div')({
  '@media print': {
    // margin: '200px',
    '& .page': {
      pageBreakAfter: 'always',
    },
  },
});

class EvaluationTemplate extends React.Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-state
    this.state = { pointIndex: 0 };
  }

  setPointIndex = (index) => {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ pointIndex: index });
  };

  render() {
    const {
      enrollment, evaluation, excludedQuestions, showReviewComments, trial,
    } = this.props;
    const { submission } = enrollment;
    const { review } = submission;
    const { reviewRequest } = review || {};
    const { reviewSurvey } = reviewRequest || {};
    const { survey } = trial;

    return (
      <StyledDiv style={{}}>
        {
          evaluation.sectionEvaluations.map((sections, index) => (
            <div key={sections.headline} className="page">
              <EvaluationSection
                trial={trial}
                evaluation={evaluation}
                excludedQuestions={excludedQuestions}
                EvaluationSecIndex={index}
              />
              {
                review
                && (
                  <ReviewSection
                    enrollment={enrollment}
                    evaluationSecIndex={index}
                    excludedQuestions={excludedQuestions}
                    review={review}
                    reviewSurvey={reviewSurvey}
                    showReviewComments={showReviewComments}
                    submission={submission}
                    survey={survey}
                  />
                )
              }
              {
                review && review.extendedPayload && review.extendedPayload.sections
                && review.extendedPayload.sections[index]
                && (
                  <MultiReviewComments
                    sectionComments={review.extendedPayload.sections[index]}
                  />
                )
              }
            </div>
          ))
        }
      </StyledDiv>
    );
  }
}

EvaluationTemplate.defaultProps = {
  excludedQuestions: undefined,
};

EvaluationTemplate.propTypes = {
  enrollment: PropTypes.object.isRequired,
  evaluation: PropTypes.object.isRequired,
  excludedQuestions: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.number,
  ]),
  showReviewComments: PropTypes.bool.isRequired,
  trial: PropTypes.object.isRequired,
};

export default EvaluationTemplate;
